module.exports = __webpack_public_path__ + "static/1 (7)-62d942a9d339e5b9ffa5e3c6137ff12d.jpg";